export default __webpack_public_path__ + "static/media/map_final_aestrin.9651b847.jpg";